import { helpers, maxValue } from '@vuelidate/validators'

export const maxValueValidator = (...params: Parameters<typeof maxValue>) =>
  helpers.withMessage(
    ({ $params }) => `El valor máximo permitido es ${$params.max}`,
    helpers.withParams({}, maxValue(...params))
  )
